import SharedResult from './SharedResult'

export default SharedResult
